import { pdfjs } from 'react-pdf';

let initialized = false;

/**
 * Sets up the pdf.js worker.
 * Primary: CDN (immediate, correct MIME type).
 * Fallback: local /public file fetched as blob — bypasses server MIME type issues.
 * Safe to call from multiple components; runs only once.
 */
export function initPdfWorker(): void {
    if (initialized) return;
    initialized = true;

    const cdnUrl = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

    // Set CDN immediately so PDFs can start loading right away
    pdfjs.GlobalWorkerOptions.workerSrc = cdnUrl;

    // In the background, try to load local worker as a blob.
    // fetch() doesn't care about MIME type — we re-wrap with application/javascript
    // so the browser accepts it as a module script even when the server misconfigures it.
    const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    fetch(`${publicBase}/pdf.worker.min.mjs`)
        .then(r => (r.ok ? r.blob() : Promise.reject()))
        .then(blob => {
            pdfjs.GlobalWorkerOptions.workerSrc = URL.createObjectURL(
                new Blob([blob], { type: 'application/javascript' })
            );
        })
        .catch(() => {
            // Local fetch failed — CDN already set, nothing more to do
        });
}
